function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_298",
  "data-name": "Group 298",
  transform: "translate(-223.412 -181.274)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_295",
  "data-name": "Group 295",
  transform: "matrix(0.883, -0.469, 0.469, 0.883, -70.708, 146.18)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_83",
  "data-name": "Ellipse 83",
  transform: "translate(225 205.137)",
  fill: "#fff",
  stroke: "#00063c",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3.427,
  cy: 3.427,
  r: 3.427,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.427,
  cy: 3.427,
  r: 2.927,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_84",
  "data-name": "Ellipse 84",
  transform: "translate(283.256 194)",
  fill: "#fff",
  stroke: "#00063c",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3.427,
  cy: 3.427,
  r: 3.427,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.427,
  cy: 3.427,
  r: 2.927,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_121",
  "data-name": "Path 121",
  d: "M215.458,203.209s1.345-8.079,13.225-8.038,19.572,9.668,30.663,9.709,13.38-6.772,13.38-6.772",
  transform: "translate(13.361 2.402)",
  fill: "none",
  stroke: "#00063c",
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_297",
  "data-name": "Group 297",
  transform: "translate(-11 1)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_85",
  "data-name": "Ellipse 85",
  cx: 12,
  cy: 12,
  r: 12,
  transform: "translate(251 190)",
  fill: "#ea5d58"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_28",
  "data-name": "Line 28",
  x2: 7,
  y2: 7,
  transform: "translate(259.5 198.5)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_29",
  "data-name": "Line 29",
  x1: 7,
  y2: 7,
  transform: "translate(259.5 198.5)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 2
})));

var SvgModalIcon = function SvgModalIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56.447,
    height: 46.452,
    viewBox: "0 0 56.447 46.452",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgModalIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/modal_icon.a8bdc797.svg";
export { ForwardRef as ReactComponent };